// extracted by mini-css-extract-plugin
export default {"pagination-container":"CommonPagination_pagination-container__jJUKF","active":"CommonPagination_active__LAdsm"};